<template>
  <div class="searchSit-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap searchSit-wrap">
        <el-form
          label-width="120px"
          :model="thirdsite"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="thirdsite.name"
              class="fl"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('server.lang')" prop="lang">
            <el-input
              v-model="thirdsite.lang"
              class="fl"
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接" prop="link">
            <el-input
              v-model="thirdsite.link"
              class="fl"
              style="width: 300px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      thirdsite: {
        name: "",
        link: "",
        lang: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        lang: [
          {
            required: true,
            message: this.$t("server.inputLang"),
            trigger: "blur"
          }
        ],
        link: [
          {
            required: true,
            message: "请输入链接",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getDetails() {
      this.$http.getThirdsiteDetails(this.$route.query.id).then(ret => {
        this.thirdsite = Object.assign({}, ret.data);
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      try {
        await this.$http.createThirdsite(this.thirdsite);
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      } catch (error) {}
    },

    async edit() {
      try {
        await this.$http.updateThirdsite(this.$route.query.id, this.thirdsite);
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        this.$router.back();
      } catch (error) {}
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getDetails();
  }
};
</script>

<style lang="scss">
.searchSit-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    &.searchSit-wrap {
      ul.parms-list {
        margin-top: 0;
      }
      .el-form-item--small .el-form-item__content {
        float: left;
        margin-left: 0 !important;
      }
    }
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .searchSit-import-btn {
        margin-top: 10px;
      }
      .searchSit-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
ul.parms-list {
  overflow: hidden;
  li {
    list-style: none;
    outline-color: transparent;
    &:hover {
      border: 0;
    }
    input {
      height: 32px;
      line-height: 32px;
      border: 1px solid #dcdfe6;
      padding: 0 5px;
      color: #555;
      outline-color: transparent;
      &:focus {
        border: 1px solid #bf735b;
      }
      &:nth-of-type(1) {
        border-bottom-left-radius: 3px;
        border-top-left-radius: 3px;
        border-right: 1px solid #eaeaea;
        width: 120px;
        &:focus {
          border-right: 1px solid #bf735b;
        }
      }
      &:nth-of-type(2) {
        border-bottom-right-radius: 3px;
        border-top-right-radius: 3px;
        width: 156px;
      }
    }
    > span {
      width: 30px;
      height: 35px;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      font-size: 20px;
      vertical-align: bottom;
      cursor: pointer;
      margin-left: 5px;
      color: #555;
    }
  }
}
</style>
